import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getSymptomsPhyto.success: {
            return action.payload;
        }

        case constants.getSymptomsPhyto.error: {
            return initialState;
        }

        case constants.getSymptomsPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}